import React from 'react'
import { Box, makeStyles, createStyles, Typography } from '@material-ui/core'
import {
  DialogActions,
  DialogBox,
  DialogButton,
  DialogContent,
  DialogTitle,
} from 'Globals/GlobalComponents/DialogBox'

const CampaignInfoModal = (props) => {
  const { campaignInfo, isModalOpen, handleDialog } = props
  const classes = useStyles()
  return (
    <DialogBox onClose={handleDialog} open={isModalOpen}>
      <DialogTitle onClose={handleDialog}>{campaignInfo.websiteName}</DialogTitle>
      <DialogContent compoment={'div'}>
        <Typography style={{ fontSize: '14px' }}>Policy URL:</Typography>
        {campaignInfo.status === 'draft' ? (
          <Typography style={{ fontSize: '12px', fontStyle: 'italic' }}>
            Please publish your policy first to get policy page URL
          </Typography>
        ) : (
          <Typography
            onClick={() =>
              window.open(`https://agitated-elion-5e05a6.netlify.app/${campaignInfo._id}`, '_blank')
            }
            style={{ fontSize: '12px', cursor: 'pointer', color: 'blue' }}
          >
            {`https://agitated-elion-5e05a6.netlify.app/${campaignInfo._id}`}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <DialogButton actionType={'primary'} onClick={handleDialog}>
          Close
        </DialogButton>
      </DialogActions>
    </DialogBox>
  )
}

const useStyles = makeStyles((theme) => createStyles({}))

export default CampaignInfoModal
